<template>
  <PrimaryButton
    v-bind="$attrs"
    color1="tertiary"
    color2="tertiaryLight"
    elevation="0"
    :disabled="!isAvailable"
    @click="openBook()"
  >
    {{
      isAudio ? audioText :
      isAvailable ? $t("bookInfo.openBook") :
      $t("bookInfo.notAvailable")
    }}
    <v-icon
      v-if="isAudio"
      size="15"
      class="ml-2 has-glow"
    >
      $headphones
    </v-icon>
  </PrimaryButton>
</template>

<script>
import { FORMATS } from "@/utils/Const";
import i18n from '@/i18n';
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";
import { openAudiobookApp } from "@/helpers/audiobookHelper";

export default {
  name: "OpenBookButton",
  components: {
    PrimaryButton,
  },
  props: {
    readUrl: {
      type: String,
      required: false,
      default: null,
    },
    format: {
      type: [String, Object],
      required: false,
      default: null,
    },
    audioText: {
      type: String,
      required: false,
      default: i18n.t("bookInfo.listenShort"),
    },
    bookId: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    formatMimeType() {
      if (!this.format) return null;
      return this.format.mimeType || this.format._id || this.format;
    },
    isAudio() {
      if (!this.formatMimeType) return false;
      return this.formatMimeType === FORMATS.audio ||
        (typeof this.formatMimeType === 'string' && this.formatMimeType.includes('audio'));
    },
    isColibrioCompatible() {
      if (!this.formatMimeType) return false;
      const mime = this.formatMimeType;

      const colibrioFormats = [FORMATS.epub, FORMATS.pdf, FORMATS.digital];
      const colibrioPatterns = ['epub', 'pdf'];

      return colibrioFormats.includes(mime) ||
        (typeof mime === 'string' && colibrioPatterns.some(p => mime.includes(p)));
    },
    isAvailable() {
      return !!this.readUrl || this.isAudio || (this.isColibrioCompatible && this.bookId);
    },
  },
  methods: {
    async openBook() {
      if (this.isAudio) {
        openAudiobookApp();
      } else if (this.isColibrioCompatible && this.bookId) {
        const readerUrl = this.$router.resolve({ name: 'reader', params: { id: this.bookId } }).href;
        window.open(readerUrl, '_blank');
      } else {
        window.open(this.readUrl);
      }
    },
  },
};
</script>
